<template>
    <div>
        <Modal
            v-model="isShow"
            class="resetpass"
            class-name="vertical-center-modal"
            :title="$t('resetPass')"
            :mask-closable="false"
            footer-hide
            width="500"
            @on-ok="ok"
            @on-cancel="cancel">
            <div class="">
                <Form :model="openModel" :rules="rules" class="loginForm" ref="resetForm" > 
                    <FormItem>
                        <effect-input :label='$t("emailAddress")' :readonly="true"  v-model="email"></effect-input>
                    </FormItem>
                    <FormItem prop="verifyCode" class="asd">
						<effect-input style="width:55%" :label='$t("asd")' v-model="openModel.verifyCode"></effect-input>
                        <Button type="primary" class="sendasd" :loading="!send" :disabled="countParams.disabled" @click="sendCode">{{countParams.txt}}</Button>
                    </FormItem>
                    <FormItem style="text-align:center;">
                        <Button type="primary"  @click="ok">{{$t('okReset')}}</Button>
                    </FormItem>
                </Form>
            </div>
        </Modal>
    <loading :isSpinShow="loading"></loading>

    </div>
</template>
<script>
	import {mapState} from 'vuex'
	import EffectInput from '@/components/EffectInput.vue';
	import _MIXINS_ from '@/mixins'
	import Loading from '@/components/Loading.vue';

    export default {
        components: {
			EffectInput,
			Loading
        },
        props: {
            openDialog: {
                type: Boolean,
                default: false
            },
			crtAccount:{
				type:Object,
				default(){
					return {}
				}
			}
        },
        data () {
            return {
                isShow: this.openDialog,
				email:'',
                openModel:{
					account:'',
                    verifyCode:''
                },
				rules:{
					verifyCode:[{
						required: true,
						message: this.$t('emailCode')
					}],
				},
				send:true,
				click:true,
				loading:false
            }
        },
		computed: {
		    ...mapState(['userInfo'])
		},
		mixins: [_MIXINS_.countdown],
        created(){
			this.email = this.userInfo.email
        },
        watch: {
            openDialog (value) {
                // console.log(value)
                this.isShow = value
			},
			crtAccount (value) {
				this.openModel.account = value.account
			}
        },
        methods: {
            ok () {
				this.$refs['resetForm'].validate((valid) => {
					if (valid) {
						if(this.click){
							this.click = false
						}else{
							return false
						}
						this.loading = true
						this.$axios.post('/api/MyAccount/ResetAccountPassword',this.openModel)
						.then(async (res) => {
							let dt = res.data
							this.click = true
						    if(dt.status == 1){
								this.$Message.success(dt.msg)
								this.cancel()
						    }else{
						        this.$Message.error(dt.msg)
						    }
						}).catch((err) => {
							this.click = true
						}).finally(() => this.loading = false)
					}
				})
            },
            cancel () {
                this.$emit('closeDialogReset',false)
				this.$refs['resetForm'].resetFields()
            },
			sendCode(){
				if(this.send){
					this.send = false
				}else{
					return false
				}
				this.$axios.get('/api/Public/SendEamilVerifyCode',{
					params:{
						email:this.userInfo.email,
						type:1,
						key:'resetaccountpassword'
					}
				})
				.then(async (res) => {
					let dt = res.data
				    
					this.send = true
				    if(dt.status == 1){
						this.countdown()
						this.$Message.success(dt.msg)
				    }else{
				        this.$Message.error(dt.msg)
				    }
				})
				.catch((err) => {
					this.send = true
				})
			}
        }
    }
</script>
<style lang="less" >
    .resetpass{
        .asd{
            .ivu-form-item-content{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .sendasd{
                    width: 42%;
                    height: 68px;
                    border-radius: 2px;
                    background-color:#FFB800 ;
					&[disabled]{
						background-color: #f7f7f7;
					}
                }
            }
        }
		.ivu-form-item-error {
			.effectInput{
				border: 1px solid #ed4014!important;
			}
		}
    }
</style>